import ChatRoomVue from '@/views/sa/chat-room/chat-room.vue';

const basePath = '/sa/chat-room';
const role = 'sa'; // 角色身份

export const SA_CHAT_ROOM_INDEX = 'sa-chat-room-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ChatRoomVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_CHAT_ROOM_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/chat-room/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
